// extracted by mini-css-extract-plugin
export var categoryName = "{strapiCategory-slug}-module--categoryName--Lijmy";
export var main = "{strapiCategory-slug}-module--main--71rTw";